import "./CommunityAndAchievements.scss";

function CommunityAndAchievements() {
  return (
    <>
      <h2>Community & Achievements</h2>
      <ul className="other-interests">
        <li className="interest">
          <p className="interest__title">
            Public Speaker · <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">Morning@Lohika</a>
          </p>
        </li>
        <li className="interest">
          <p className="interest__title">
            Co-founder & Speaker · <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">JS Vechornytsi</a>
          </p>
        </li>
        <li className="interest">
          <p className="interest__title">
            Lecturer & Mentor · <a href="https://circle.if.ua" target="_blank" rel="noopener noreferrer">Circle Academy</a>
          </p>
          <p className="interest__description">
            JavaScript lecturer; Front-end and Back-end mentor
          </p>
        </li>
        <li className="interest">
          <p className="interest__title">
            Hackathon Winner · <a href="https://itcluster.lviv.ua" target="_blank" rel="noopener noreferrer">Lviv IT Cluster</a>
          </p>
          <p className="interest__description">
            1st Place, Lviv Best-Hackathon — Web Development
          </p>
        </li>
      </ul>
    </>
  );
}

export { CommunityAndAchievements };
